export const CrewWelfareRoutes = {
    SubmitCWSAClientSearchTool: "CrewWelfare/SubmitCWSASearchTool",
    VerifyExpiryDateAccessCWSASearchTool: "CrewWelfare/VerifyExpiryDateAccessCWSASearchTool",
    CheckCWStatusByDOCCompanyOrVessel: "CrewWelfare/CheckCWStatusByDOCCompanyOrVessel"
}
